import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer, createTransform } from 'redux-persist';

import thunk from 'redux-thunk';
import promise from 'redux-promise';
import logger from 'redux-logger';
import LocalForage from 'localforage';

import { ENV } from '../constants/app';

import { reducer as formReducer } from 'redux-form';

import {
  accountReducer,
  adminReducer,
  agentReducer,
  agentsPaymentReducer,
  clientReducer,
  collectionReducer,
  contractReducer,
  customerReducer,
  detailsPanelReducer,
  domiciliationPermissionsReducer,
  errorsReducer,
  integrationsReducer,
  invoiceReducer,
  loginReducer,
  notificationsReducer,
  paymentAccountReducer,
  paymentReducer,
  permsReducer,
  sidebarReducer,
  suraRolePermissionsReducer,
  suraSmsTemplateReducer,
  themeReducer,
  topbarNotificationsReducer,
} from '../redux/reducers/index';

let createStoreWithMiddleware;

const clientTransform = createTransform(
  (inboundState, key) => {
    if (key === 'clientReducer') {
      const { receipts, ...persistedState } = inboundState;
      return persistedState;
    }
    return inboundState;
  },
  (outboundState, key) => {
    if (key === 'clientReducer') {
      return { ...outboundState, receipts: [] };
    }
    return outboundState;
  },
  { whitelist: ['clientReducer'] }
);

const agentTransform = createTransform(
  (inboundState, key) => {
    if (key === 'agentReducer') {
      const currentPath = window.location.pathname;
      if (currentPath === '/cobranza/agente') {
        const { selected, ...persistedState } = inboundState;
        return persistedState;
      }
      return inboundState;
    }
    return inboundState;
  },
  (outboundState, key) => {
    if (key === 'agentReducer') {
      return { ...outboundState, selected: [] };
    }
    return outboundState;
  },
  { whitelist: ['agentReducer'] }
);

const persistConfig = {
  key: 'primary',
  storage: LocalForage,
  whitelist: ['account', 'admin', 'form', 'perms', 'integrations', 'suraRolePermissions', 'paymentAccount', 'agentReducer', 'clientReducer', 'domiciliationPermissions'],
  transforms: [clientTransform, agentTransform]
};

const formPlugin = {
  LOG_IN_FORM: (state, action) => {
    switch (action.type) {
      case 'persist/REHYDRATE':
        return {};
      default:
        return state;
    }
  }
};

const forms = formReducer.plugin(formPlugin);

const rootReducer = combineReducers({
  account                  : accountReducer,
  admin                    : adminReducer,
  agentReducer             : agentReducer,
  agentsPayment            : agentsPaymentReducer,
  clientReducer            : clientReducer,
  collection               : collectionReducer,
  contracts                : contractReducer,
  customers                : customerReducer,
  detailsPanel             : detailsPanelReducer,
  domiciliationPermissions : domiciliationPermissionsReducer,
  errors                   : errorsReducer,
  form                     : forms,
  integrations             : integrationsReducer,
  invoices                 : invoiceReducer,
  login                    : loginReducer,
  notifications            : notificationsReducer,
  paymentAccount           : paymentAccountReducer,
  payment                  : paymentReducer,
  perms                    : permsReducer,
  sidebar                  : sidebarReducer,
  suraRolePermissions      : suraRolePermissionsReducer,
  suraSmsTemplate          : suraSmsTemplateReducer,
  theme                    : themeReducer,
  topbarNotifications      : topbarNotificationsReducer,
});

const reducer = persistReducer(persistConfig, rootReducer);

if (ENV === 'production') {
  createStoreWithMiddleware = compose(
    applyMiddleware(promise, thunk)
  )(createStore);
} else {
  createStoreWithMiddleware = compose(
    applyMiddleware(promise, thunk, logger)
  )(createStore);
}

export const store = createStoreWithMiddleware(reducer);
export default store;
export const persistor = persistStore(store);

var localStorageEnabled = false;
try { localStorageEnabled = !!localStorage; } catch (e) { console.error(e); }

if (localStorageEnabled) window.onerror = localStorage.clear.bind(localStorage);



// WEBPACK FOOTER //
// ./src/app/store.js